<template>
  <div
    class="flex items-center justify-center h-full cursor-pointer"
    @click.stop="toggle"
  >
    <checkbox table :value="selected" />
  </div>
</template>

<script>
import { Checkbox } from '@/components/Inputs';

export default {
  components: { Checkbox },
  data() {
    return {
      selected: false,
    };
  },
  beforeMount() {
    this.updateSelection();
  },
  methods: {
    refresh() {
      this.updateSelection();
      return true;
    },
    updateSelection() {
      this.selected = this.params.isSelected(this.params.data);
    },
    toggle() {
      this.params.onToggle(this.params.data);
      this.updateSelection();
    },
  },
};
</script>
